import {
  CellClickedEvent,
  ColDef,
  ValueFormatterParams,
} from "ag-grid-community";
import { GenericGrid } from "../../grid/GenericGrid";
import {
  GridDataRequest,
  GridDataResponse,
  PatientsApi,
} from "patients-experience-client";
import { createUsersApi } from "../../api-helpers/UserApiHelper";
import { UsersDto } from "users-experience-client";
import { createGridApi } from "../../api-helpers/GridApiHelper";
import CustomButtonRenderer from "../../renderers/CustomButtonRenderer";
import { useState } from "react";
import OffCanvas from "../../components/offCanvas";
import AddUpdateUser from "./AddUpdateUser";

export const UserAdministration = () => {
  const gridApi = createGridApi();
  const usersApi = createUsersApi();

  const [selectedUser, setSelectedUser] = useState<UsersDto>();
  const [offCanvas, setOffCanvas] = useState({
    title: "",
    subTitle: "",
    display: false,
    comp: "",
  });

  const loadData = async (
    request: GridDataRequest,
  ): Promise<GridDataResponse> => {
    const gridDataRequest: GridDataRequest = {
      filters: [],
      sortCriteria: [],
      startRow: 0,
      endRow: 100,
    };

    return (await gridApi.gridControllerGetUsersGridData(gridDataRequest)).data;
  };

  const handleUpdateUser = async (userId: string) => {
    await loadUserDetails(userId);
    handleOffCanvasShow("updateUser");
  };

  const loadUserDetails = async (userId: string) => {
    try {
      const response = await usersApi.usersControllerFindOne(userId);
      setSelectedUser(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleOffCanvasShow = (comp: string) => {
    let offCanvasTitle = "";
    const offCanvasSubTitle = "";

    if (comp === "updateUser") {
      offCanvasTitle = "Edit Care Team Member";
    }

    setOffCanvas({
      ...offCanvas,
      display: !offCanvas.display,
      title: offCanvasTitle,
      subTitle: offCanvasSubTitle,
      comp: comp,
    });
  };

  const colDefs: ColDef[] = [
    {
      field: "firstName",
      headerName: "First Name",
      width: 150,
      minWidth: 100,
      cellClass: "cursor-pointer",
      sortable: true,
      pinned: true,
    },
    {
      field: "lastName",
      headerName: "Last Name",
      width: 150,
      minWidth: 100,
      cellClass: "cursor-pointer",
      sortable: true,
      pinned: true,
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 200,
      minWidth: 250,
      cellClass: "cursor-pointer",
      sortable: true,
    },
    {
      field: "userRoleName",
      headerName: "User Role",
      width: 180,
      minWidth: 150,
      cellClass: "cursor-pointer",
      sortable: true,
    },
    {
      field: "licensedStates",
      headerName: "Licensed State(s)",
      width: 300,
      minWidth: 250,
      cellClass: "cursor-pointer",
      sortable: true,
    },
    {
      field: "appointmentTypes",
      headerName: "Appointment Type(s)",
      width: 180,
      minWidth: 150,
      cellClass: "cursor-pointer",
      sortable: true,
    },
    {
      field: "timeZone",
      headerName: "Time Zone",
      width: 250,
      minWidth: 200,
      cellClass: "cursor-pointer",
      sortable: true,
    },
    // {
    //     cellRenderer: CustomButtonRenderer,
    //     onCellClicked: (event: CellClickedEvent) => {
    //         handleUpdateUser(event.data.id);
    //     },
    //     width: 50,
    //     pinned: "right",
    //     resizable: false,
    //     sortable:false
    // },
  ];

  return (
    <>
      <div className="d-flex px-3 px-md-4 px-lg-5 d-flex align-items-stretch">
        <div className="flex-fill">
          <div className="py-4">
            <GenericGrid
              gridId="user-administration-grid"
              colDefs={colDefs}
              dataProvider={loadData}
              filters={[]}
            />
          </div>
        </div>
      </div>
      <OffCanvas
        title={offCanvas.title}
        subTitle={offCanvas.subTitle}
        offCanvasShow={offCanvas.display}
        setOffCanvasShow={(displayOffCanvas: boolean) => {
          setOffCanvas((prevState) => ({
            ...prevState,
            display: displayOffCanvas,
          }));
        }}
        offCanvasComp={offCanvas.comp}
      >
        {offCanvas.comp === "updateUser" && (
          <AddUpdateUser
            user={selectedUser}
            onSubmitUser={(toasterConfig: any) => {}}
            setOffCanvasShow={(displayOffCanvas: boolean) => {
              setOffCanvas((prevState) => ({
                ...prevState,
                display: displayOffCanvas,
              }));
            }}
          />
        )}
      </OffCanvas>
    </>
  );
};
